module.exports = __webpack_public_path__ + "assets/bottom-nav-profile.b70249dd.svg";